import { render, staticRenderFns } from "./manageQuestion.vue?vue&type=template&id=5d9f28e8&scoped=true"
import script from "./manageQuestion.vue?vue&type=script&lang=js"
export * from "./manageQuestion.vue?vue&type=script&lang=js"
import style0 from "./manageQuestion.vue?vue&type=style&index=0&id=5d9f28e8&prod&lang=scss"
import style1 from "./manageQuestion.vue?vue&type=style&index=1&id=5d9f28e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9f28e8",
  null
  
)

export default component.exports